import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";

export function HideAllLinesCommand(): Contract<void> {

    Components.lines.hideAllLines();

    return new Contract<void>((resolve) => { resolve(null); });
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/lines/hide-all-lines-command.ts